import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import { connect } from 'react-redux';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';

export class VoucherTableHead extends Component {
  state = {
    role: ROLE_USER,
  };

  static getDerivedStateFromProps(props) {
    let newState = null;
    if (props.authUser && props.roles) {
      const role = props.roles[props.authUser.uid];
      newState = { ...newState, role };
    }
    return newState;
  }

  createSortHandler = property => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy } = this.props;

    const columnData = [
      {
        id: 'code', numeric: true, disablePadding: false, label: 'Code',
      },
      {
        id: 'type', numeric: false, disablePadding: false, label: 'Type',
      },
      {
        id: 'renterName', numeric: false, disablePadding: false, label: 'Loueur',
      },
      {
        id: 'siteName', numeric: false, disablePadding: false, label: 'Sites',
      },
      {
        id: 'value', numeric: false, disablePadding: false, label: 'Valeur (en euros)',
      },
      {
        id: 'percent', false: true, disablePadding: false, label: 'Réduction (en %)',
      },
      {
        id: 'end_date', false: true, disablePadding: false, label: 'Date de fin de validité',
      }
    ];

    if (this.state.role < ROLE_ADMIN) {
      columnData.splice(columnData.findIndex(column => column.id === 'renterName'), 1);
    }
    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => (
            <TableCell
              key={column.id}
              padding={column.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === column.id ? order : false}>
              <Tooltip
                title="Trier"
                placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                enterDelay={300}>
                <TableSortLabel
                  active={orderBy === column.id}
                  direction={order === 'asc' ? 'desc' : 'asc'}
                  onClick={this.createSortHandler(column.id)}>
                  {column.label}
                </TableSortLabel>
              </Tooltip>
            </TableCell>
          ), this)}
          <TableCell padding="checkbox">
          </TableCell>
        </TableRow>
      </TableHead>
    );
  }
}

VoucherTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
};

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
  };
}

export default connect(mapStateToProps)(VoucherTableHead);



// WEBPACK FOOTER //
// ./src/components/Voucher/VoucherTableHead.jsx